import React, {useState} from 'react';
import cx from 'classnames';

import Button, {ButtonTypes} from '../../components/ButtonNew';

const CourseAuthors = ({authors, authorHeadline, truncateAfter = 5}) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="py-6 pb-10 lg:pt-16 px-4 flex flex-col items-center justify-center max-w-5xl">
      <h2 className="text-xl lg:text-2xl font-bold text-black text-center">
        {`Taught by ${authorHeadline}`}
      </h2>
      <div className="mt-8 lg:mt-12 flex lg:flex-row flex-wrap items-start justify-center gap-4 lg:gap-10">
        {authors.slice(0, truncateAfter).map((author) => (
          <div
            key={author.name}
            className="flex lg:w-40 flex-grow-0 lg:flex-col items-center text-center gap-2"
          >
            <img
              src={`${author.image}?w=200&h=200`}
              alt={author.name}
              className="w-10 h-10 lg:w-16 lg:h-16 rounded-full object-cover"
              loading="lazy"
            />
            <div className="hidden lg:flex flex-col justify-center lg:justify-center text-left lg:text-center">
              <span className="text-sm lg:text-lg text-black font-semibold">{author.name}</span>
              <span className="text-xs lg:text-sm text-gray-600 font-regular">{author.title}</span>
            </div>
          </div>
        ))}
      </div>
      {showAll && authors.length > truncateAfter && (
        <div className="hidden lg:flex flex-wrap mt-10 items-start justify-center gap-6">
          {authors.slice(truncateAfter).map((author) => (
            <div key={author.name} className="w-40 flex flex-col items-center justify-start flex-grow-0">
              <div className="flex flex-col justify-center lg:justify-center text-left lg:text-center">
                <span className="text-sm text-gray-900 font-semibold">{author.name}</span>
                <span className="text-xs text-gray-500 font-regular">{author.title}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      {authors.length > truncateAfter && (
        <Button className="hidden lg:flex mt-10" buttonType={ButtonTypes.TERTIARY} onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Show less' : 'Show all'}
        </Button>
      )}
    </div>
  );
};

export default CourseAuthors;
